import { Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormControl } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DEFAULT_DIALOG_OFFWHITE_CLASS, DEFAULT_ERROR_MESSAGE, LoggingService } from "@merri/common";
import { of, Subscription } from "rxjs";
import { catchError, take, tap } from "rxjs/operators";
import { VisionboardVersion } from "../../models";
import { VisionboardVersionsService } from "../../services";

@Component({
    selector: "app-visionboard-version-rename-dialog",
    templateUrl: "./visionboard-version-rename-dialog.component.html",
    styleUrls: ["./visionboard-version-rename-dialog.component.scss"],
    standalone: false
})
export class VisionboardVersionRenameDialogComponent implements OnInit, OnDestroy {
  private backdropClickSub$: Subscription;

  nameControl: UntypedFormControl;
  saving: boolean;
  error: string;

  @ViewChild("nameInput", { static: true }) nameInput: ElementRef;

  constructor(
    private _dialog: MatDialogRef<VisionboardVersionRenameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public selectedVersion: VisionboardVersion,
    private visionboardVersionsService: VisionboardVersionsService,
    private formBuilder: UntypedFormBuilder,
  ) {}

  @HostListener("window:keydown.escape")
  onEscapeClick() {
    if (this.saving) return;
    this._dialog.close();
  }

  ngOnInit() {
    this._dialog.disableClose = true;
    this._dialog.addPanelClass([DEFAULT_DIALOG_OFFWHITE_CLASS, "visionboard-version-rename-dialog"]);

    this.backdropClickSub$ = this._dialog.backdropClick().subscribe({
      next: () => this.onEscapeClick(),
    });

    this.nameControl = this.formBuilder.control(this.selectedVersion.visionboardName);

    setTimeout(() => {
      this.nameInput.nativeElement.focus();
    }, 100);
  }

  ngOnDestroy() {
    if (this.backdropClickSub$) this.backdropClickSub$.unsubscribe();
  }

  onCloseButtonClick() {
    this._dialog.close();
  }

  onSaveButtonClick() {
    this.saving = true;
    this.nameControl.disable();

    this.visionboardVersionsService
      .saveVersionName$(this.selectedVersion, this.nameControl.value)
      .pipe(
        take(1),
        tap(success => {
          LoggingService.log(`VisionboardVersionRenameDialogComponent - versionNameChangedSub - success ${success}`);

          if (success) {
            this._dialog.close();
          } else {
            this.error = DEFAULT_ERROR_MESSAGE;
            this.saving = false;
            this.nameControl.enable();
          }
        }),
        catchError(err => {
          LoggingService.log("VisionboardWorkspaceControlsComponent - versionNameChangedSub - fail inner");

          this.error = err;
          this.saving = false;
          this.nameControl.enable();

          return of(false);
        }),
      )
      .subscribe();
  }
}
